import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight, BoxIcon } from 'lucide-react';
interface PillarTileProps {
  title: string;
  description: string;
  icon: BoxIcon;
  bgColor: string; // Tailwind class like 'bg-blue-500'
  ctaText: string;
  ctaLink: string;
}
export const PillarTile: React.FC<PillarTileProps> = ({
  title,
  description,
  icon: Icon,
  bgColor,
  ctaText,
  ctaLink
}) => {
  return <Link to={ctaLink} className="block h-full" data-id="element-154">
      <motion.div whileHover={{
      y: -4,
      scale: 1.02
    }} className={`${bgColor} text-white p-8 rounded-2xl h-full flex flex-col shadow-md hover:shadow-xl transition-all duration-300`} data-id="element-155">
        <div className="mb-6 bg-white/20 w-16 h-16 rounded-full flex items-center justify-center backdrop-blur-sm" data-id="element-156">
          <Icon className="w-8 h-8 text-white" data-id="element-157" />
        </div>
        <h3 className="text-2xl font-bold mb-3" data-id="element-158">{title}</h3>
        <p className="text-white/90 mb-8 flex-grow leading-relaxed font-medium" data-id="element-159">
          {description}
        </p>
        <div className="flex items-center font-bold text-sm uppercase tracking-wide bg-white/20 self-start px-4 py-2 rounded-full hover:bg-white/30 transition-colors" data-id="element-160">
          {ctaText}
          <ArrowRight className="w-4 h-4 ml-2" data-id="element-161" />
        </div>
      </motion.div>
    </Link>;
};